var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPastilles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.271,
    height: 58.365,
    viewBox: "0 0 68.271 58.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 68.271,
    height: 58.365,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_273",
    "data-name": "Groupe 273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_272",
    "data-name": "Groupe 272",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_549",
    "data-name": "Trac\\xE9 549",
    d: "M28.97,30.143H28.8c-5.567-.03-11.2-1.644-11.179-4.67.016-3,5.554-4.549,11.069-4.549h.162A23.294,23.294,0,0,1,36.429,22.1c2.986,1.092,3.606,2.5,3.6,3.495s-.642,2.4-3.639,3.454a23.094,23.094,0,0,1-7.421,1.093m-.286-7.388c-5.548,0-9.226,1.631-9.232,2.727s3.724,2.8,9.359,2.828a21.015,21.015,0,0,0,6.971-.989c1.666-.587,2.414-1.295,2.417-1.735h0c0-.441-.738-1.158-2.4-1.763a21.423,21.423,0,0,0-6.96-1.067Z",
    transform: "translate(-1.483 -1.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_550",
    "data-name": "Trac\\xE9 550",
    d: "M28.926,37.717h-.167c-5.567-.03-11.195-1.646-11.179-4.672a.917.917,0,0,1,.916-.911h0a.916.916,0,0,1,.911.92c-.006,1.106,3.724,2.8,9.359,2.831h.158a21.246,21.246,0,0,0,6.814-.991c1.667-.588,2.414-1.295,2.417-1.736a.916.916,0,0,1,.916-.911h0a.916.916,0,0,1,.911.92c-.005.993-.64,2.4-3.639,3.455a23.139,23.139,0,0,1-7.425,1.093",
    transform: "translate(-1.48 -2.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_551",
    "data-name": "Trac\\xE9 551",
    d: "M40.966,33.48H40.96a.916.916,0,0,1-.91-.921l.037-6.63a.916.916,0,0,1,.916-.91h.005a.916.916,0,0,1,.91.921l-.037,6.63a.916.916,0,0,1-.916.91",
    transform: "translate(-3.372 -2.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_552",
    "data-name": "Trac\\xE9 552",
    d: "M18.5,33.356H18.49a.916.916,0,0,1-.91-.921l.037-6.63a.916.916,0,0,1,.916-.91h.005a.916.916,0,0,1,.91.921l-.037,6.63a.916.916,0,0,1-.916.91",
    transform: "translate(-1.48 -2.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_553",
    "data-name": "Trac\\xE9 553",
    d: "M34.489,40.278h-.171a23.965,23.965,0,0,1-7.734-1.138.915.915,0,1,1,.63-1.719,22.144,22.144,0,0,0,7.115,1.026,21.722,21.722,0,0,0,6.971-.989c1.667-.588,2.414-1.295,2.417-1.736,0-.475-1.137-1.572-3.9-2.079a.916.916,0,0,1,.332-1.8c3.289.6,5.408,2.13,5.4,3.89-.005.992-.64,2.4-3.639,3.454a23.123,23.123,0,0,1-7.421,1.093",
    transform: "translate(-2.187 -2.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_554",
    "data-name": "Trac\\xE9 554",
    d: "M43.758,46.447a.916.916,0,0,1-.372-1.753c1.263-.56,1.713-1.136,1.714-1.459a.916.916,0,0,1,.916-.911h0a.916.916,0,0,1,.911.92c0,.86-.495,2.1-2.8,3.124a.9.9,0,0,1-.37.079",
    transform: "translate(-3.606 -3.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_555",
    "data-name": "Trac\\xE9 555",
    d: "M46.224,43.546h-.005a.916.916,0,0,1-.91-.921l.037-6.631a.916.916,0,0,1,.916-.91h.005a.916.916,0,0,1,.91.921l-.037,6.631a.916.916,0,0,1-.916.91",
    transform: "translate(-3.814 -2.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_556",
    "data-name": "Trac\\xE9 556",
    d: "M28.8,52.05h-.16a22.6,22.6,0,0,1-6.285-.72.916.916,0,1,1,.508-1.76,20.938,20.938,0,0,0,5.787.648,27.076,27.076,0,0,0,3.723-.238.916.916,0,0,1,.255,1.814,27.888,27.888,0,0,1-3.827.256",
    transform: "translate(-1.826 -4.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_557",
    "data-name": "Trac\\xE9 557",
    d: "M38.985,46.787a.915.915,0,0,1-.723-.354c-.886-1.138-4.4-2.363-9.171-2.388h-.133c-.534,0-.887-.006-1.423.026a.9.9,0,0,1-.969-.859.915.915,0,0,1,.86-.969c.581-.034.961-.033,1.542-.029H29.1c5,.027,9.165,1.242,10.605,3.1a.916.916,0,0,1-.722,1.478",
    transform: "translate(-2.236 -3.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_558",
    "data-name": "Trac\\xE9 558",
    d: "M28.854,59.3h-.172a26.694,26.694,0,0,1-5.34-.546.915.915,0,0,1,.383-1.79,24.8,24.8,0,0,0,4.966.5,25.813,25.813,0,0,0,3.869-.258.915.915,0,1,1,.267,1.811,27.472,27.472,0,0,1-3.973.279",
    transform: "translate(-1.904 -4.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_559",
    "data-name": "Trac\\xE9 559",
    d: "M43.929,54.144h-.193c-5.567-.03-11.2-1.645-11.179-4.671.017-3,5.554-4.548,11.069-4.548h.162a22.364,22.364,0,0,1,6.1.8.916.916,0,1,1-.49,1.765,20.606,20.606,0,0,0-5.618-.733H43.62c-5.548,0-9.226,1.631-9.232,2.726s3.723,2.8,9.359,2.829a20.566,20.566,0,0,0,6.193-.819.917.917,0,0,1,.551,1.748,21.36,21.36,0,0,1-6.562.9",
    transform: "translate(-2.741 -3.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_560",
    "data-name": "Trac\\xE9 560",
    d: "M43.85,61.695H43.7c-5.567-.03-11.2-1.646-11.179-4.672a.916.916,0,0,1,.916-.911h0a.916.916,0,0,1,.911.92c-.006,1.106,3.724,2.8,9.359,2.831,4.657.039,7.947-1.155,9.037-2.262a1.154,1.154,0,0,0,.408-.795.916.916,0,0,1,.9-.933h.017a.915.915,0,0,1,.916.9,2.937,2.937,0,0,1-.934,2.116c-1.688,1.712-5.679,2.808-10.2,2.808",
    transform: "translate(-2.737 -4.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_561",
    "data-name": "Trac\\xE9 561",
    d: "M33.432,57.356h-.005a.916.916,0,0,1-.91-.921l.037-6.63a.916.916,0,0,1,.916-.91h.005a.916.916,0,0,1,.91.921l-.037,6.63a.916.916,0,0,1-.916.91",
    transform: "translate(-2.737 -4.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_562",
    "data-name": "Trac\\xE9 562",
    d: "M15.252,44.078h-.162A23.315,23.315,0,0,1,7.512,42.9c-2.986-1.092-3.606-2.5-3.6-3.495s.64-2.4,3.639-3.454a23.3,23.3,0,0,1,7.591-1.094c5.567.031,11.2,1.646,11.179,4.672h0c-.017,3-5.554,4.547-11.069,4.547m-.278-7.389a21.247,21.247,0,0,0-6.814.991c-1.666.588-2.414,1.295-2.417,1.736s.738,1.158,2.4,1.764a21.449,21.449,0,0,0,6.96,1.066h.157c5.548,0,9.226-1.631,9.232-2.726s-3.724-2.8-9.359-2.83h-.158m10.432,2.836h0Z",
    transform: "translate(-0.329 -2.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_563",
    "data-name": "Trac\\xE9 563",
    d: "M15.212,51.652h-.162a23.29,23.29,0,0,1-7.577-1.178c-2.986-1.092-3.606-2.5-3.6-3.495a.916.916,0,0,1,.916-.91h.005a.916.916,0,0,1,.91.921c0,.441.738,1.158,2.4,1.763a21.423,21.423,0,0,0,6.96,1.067h.156c5.548,0,9.227-1.631,9.233-2.727a.916.916,0,0,1,.916-.91h.005a.916.916,0,0,1,.91.921c-.017,3-5.554,4.548-11.069,4.548",
    transform: "translate(-0.326 -3.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_564",
    "data-name": "Trac\\xE9 564",
    d: "M27.257,47.416h-.005a.916.916,0,0,1-.91-.921l.037-6.63a.916.916,0,0,1,.916-.91H27.3a.916.916,0,0,1,.91.921l-.037,6.63a.916.916,0,0,1-.916.91",
    transform: "translate(-2.217 -3.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_565",
    "data-name": "Trac\\xE9 565",
    d: "M4.787,47.292H4.781a.916.916,0,0,1-.91-.921l.037-6.63a.916.916,0,0,1,.916-.91h.005a.916.916,0,0,1,.91.921L5.7,46.382a.916.916,0,0,1-.916.91",
    transform: "translate(-0.326 -3.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_566",
    "data-name": "Trac\\xE9 566",
    d: "M11.385,55.714h-.167a23.316,23.316,0,0,1-7.577-1.177C.655,53.445.035,52.033.04,51.041c.006-1.162.785-2.756,4.458-3.749a.916.916,0,1,1,.478,1.768c-2.284.617-3.1,1.434-3.1,1.991,0,.442.738,1.158,2.4,1.764a21.449,21.449,0,0,0,6.96,1.066h.16c5.546,0,9.222-1.631,9.229-2.727,0-.119,0-.155-.18-.367A.916.916,0,1,1,21.829,49.6a2.216,2.216,0,0,1,.621,1.569c-.017,3-5.551,4.548-11.065,4.549",
    transform: "translate(-0.003 -3.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_567",
    "data-name": "Trac\\xE9 567",
    d: "M11.341,63.217h-.162A23.289,23.289,0,0,1,3.6,62.039C.615,60.947-.005,59.536,0,58.544a.89.89,0,0,1,.921-.91.916.916,0,0,1,.91.921c0,.441.738,1.158,2.4,1.763a21.423,21.423,0,0,0,6.96,1.067h.156c5.548,0,9.227-1.631,9.233-2.727a.916.916,0,0,1,.916-.91H21.5a.916.916,0,0,1,.91.921c-.017,3-5.554,4.548-11.069,4.548",
    transform: "translate(0 -4.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_568",
    "data-name": "Trac\\xE9 568",
    d: "M23.386,58.98H23.38a.916.916,0,0,1-.91-.921l.037-6.63a.916.916,0,0,1,.916-.91h.005a.916.916,0,0,1,.91.921L24.3,58.07a.916.916,0,0,1-.916.91",
    transform: "translate(-1.892 -4.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_569",
    "data-name": "Trac\\xE9 569",
    d: "M.916,58.856H.91A.916.916,0,0,1,0,57.935l.037-6.63a.916.916,0,0,1,.916-.91H.958a.916.916,0,0,1,.91.921l-.037,6.63a.916.916,0,0,1-.916.91",
    transform: "translate(0 -4.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_570",
    "data-name": "Trac\\xE9 570",
    d: "M69.317,54.511c-2.466,0-5.875-1.255-8.933-3.05-4.8-2.818-8.863-7.035-7.332-9.646s7.194-1.124,12,1.694,8.863,7.035,7.332,9.645a3.293,3.293,0,0,1-3.063,1.356m2.274-1.82h0ZM56.057,42.29c-.753,0-1.254.16-1.426.452-.559.954,1.82,4.289,6.679,7.14s8.931,3.3,9.492,2.347-1.821-4.289-6.679-7.14a17.949,17.949,0,0,0-8.066-2.8",
    transform: "translate(-4.438 -3.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_571",
    "data-name": "Trac\\xE9 571",
    d: "M65.655,60.838c-2.466,0-5.875-1.255-8.934-3.05a23.257,23.257,0,0,1-5.967-4.817c-2.038-2.441-1.867-3.973-1.365-4.828a.916.916,0,0,1,1.58.928c-.223.379.058,1.37,1.191,2.726a21.441,21.441,0,0,0,5.488,4.411c4.861,2.852,8.932,3.3,9.491,2.347a.916.916,0,1,1,1.58.927,3.3,3.3,0,0,1-3.063,1.355",
    transform: "translate(-4.13 -4.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_572",
    "data-name": "Trac\\xE9 572",
    d: "M69.577,60.367a.905.905,0,0,1-.462-.126.915.915,0,0,1-.326-1.253l3.355-5.718a.915.915,0,1,1,1.579.927l-3.355,5.718a.914.914,0,0,1-.79.452",
    transform: "translate(-5.78 -4.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_573",
    "data-name": "Trac\\xE9 573",
    d: "M50.2,49a.9.9,0,0,1-.462-.126.915.915,0,0,1-.326-1.253L52.762,41.9a.915.915,0,1,1,1.579.927l-3.355,5.719A.914.914,0,0,1,50.2,49",
    transform: "translate(-4.149 -3.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_574",
    "data-name": "Trac\\xE9 574",
    d: "M36.031,14.947a.917.917,0,0,1-.914-.866L34.412.965a.916.916,0,0,1,1.83-.1l.705,13.115a.917.917,0,0,1-.865.964h-.05",
    transform: "translate(-2.897 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_575",
    "data-name": "Trac\\xE9 575",
    d: "M44.961,19.812a.916.916,0,0,1-.711-1.493l6.87-8.479a.916.916,0,0,1,1.423,1.154l-6.87,8.479a.916.916,0,0,1-.713.339",
    transform: "translate(-3.708 -0.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_576",
    "data-name": "Trac\\xE9 576",
    d: "M50.246,27.925a.915.915,0,0,1-.182-1.812l12.47-2.544a.916.916,0,1,1,.366,1.794L50.43,27.906a.9.9,0,0,1-.184.019",
    transform: "translate(-4.153 -1.982)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastilles);
export default __webpack_public_path__ + "static/media/PASTILLES.d25db4de410ad1c1358cc55469d77514.svg";
export { ForwardRef as ReactComponent };